import { createStore } from 'jotai';

export const defaultStore = createStore();
